<template lang='pug'>
  include /mixins
  events-filter-ui(
    :disabled="loading"
    :value="prepared"
    :filters="filters"
    :pagination='pagination'
    @input="handleInputFilter"
  )
    template(#prepend='')
      +b.g-cell.g-cols--12.--3-xl
        +b.tt-link--appearance_inline.--variant_start.--weight_semibold.--text-8.--size_sm.SPAN.tt-space_mt--7(
          @click.prevent='handleInputFilter({})'
        ) {{ _('Очистить фильтр') }}

</template>

<script>

import EventsFilterUi from '@app/Events/Filters/Ui'
import ControllerMixin from '@app/FiltersSimple/mixins/ControllerMixin'

export default {
  mixins: [ControllerMixin],
  components: {
    EventsFilterUi,
  },
  created() {
    this.receive()
  },

}
</script>
